import { render } from "./MarketplacesOverview.vue?vue&type=template&id=d5c2acbc"
import script from "./MarketplacesOverview.vue?vue&type=script&lang=ts"
export * from "./MarketplacesOverview.vue?vue&type=script&lang=ts"

import "./MarketplacesOverview.vue?vue&type=style&index=0&id=d5c2acbc&lang=scss"
script.render = render

export default script